<template>
  <v-textarea
    :id="id"
    :label="label"
    :loading="loading"
    :disabled="disabled"
    :hide-details="hideDetails"
    outlined
    :auto-grow="autoGrow"
    :rows="rows"
    no-resize
    :class="[{ 'mt-2 pt-0': !hideTopMargin }]"
    :counter="counter"
    :counter-value="(v) => (v ? v.length : 0)"
    :hint="`Max character limit ${counter}`"
    persistent-hint
    v-on:keypress="$emit('keypress', $event)"
    v-on:paste="$emit('paste', $event)"

    v-model="textareainput"
    :placeholder="placeholder"
  ></v-textarea>
</template>
<script>
export default {
  name: "textarea-input",
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    hideTopMargin: {
      type: Boolean,
      default: false,
    },
    counter: {
      type: [String, Number],
      default: 250,
    },
    value: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: null,
    },
    id: {
      type: String,
      default: null,
    },
    rows: {
      type: Number,
      default: 3,
    },
    label: {
      type: String,
      default: null,
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    autoGrow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      textareainput: null,
    };
  },
  watch: {
    value() {
      this.textareainput = this.value;
    },
    textareainput() {
      this.$emit("input", this.textareainput);
    },
  },
  mounted() {
    this.textareainput = this.value;
  },
};
</script>
